var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide",style:(_vm.style)},[(_vm.withOverlay)?_c('div',{staticClass:"overlay"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-943a3e7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/components/SlideShow/SlideShowItem.vue
// module id = 5c8s
// module chunks = 1